import { render, staticRenderFns } from "./imprimircompra.vue?vue&type=template&id=1b4c99bb"
import script from "./imprimircompra.vue?vue&type=script&lang=js"
export * from "./imprimircompra.vue?vue&type=script&lang=js"
import style0 from "./imprimircompra.vue?vue&type=style&index=0&id=1b4c99bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports